import React from 'react'

export default function Submit({ style = 'btn-primary text-light', onSubmit, text, sending, disabled = false, hidden = false }) {
  return (
    <button hidden={hidden} class={`btn ${style}`} type='submit' onClick={e => onSubmit(e)} disabled={disabled || sending}>
      {sending ? <i class='fas fa-circle-notch fa-spin' /> : text}
    </button>
  )
}
